var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { get } from 'lodash';
import React, { Component, useContext } from 'react';
import { FormContext } from './AutosaveForm';
export function useAutoSaveField(_a) {
    var field = _a.field;
    // Work around to make context more type safe.
    var autosaveContext = useContext(FormContext);
    var fieldValue = get(autosaveContext.formValues, field);
    var fieldError = get(autosaveContext.errors, field, '');
    var fieldDirty = get(autosaveContext.dirty, field, false);
    var fieldTouched = get(autosaveContext.touched, field, false);
    return {
        fieldValue: fieldValue,
        error: fieldError,
        dirty: fieldDirty,
        touched: fieldTouched,
        field: field,
        form: autosaveContext,
        onChange: autosaveContext.onChange(field)
    };
}
var AutosaveField = /** @class */ (function (_super) {
    __extends(AutosaveField, _super);
    function AutosaveField() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AutosaveField.prototype.render = function () {
        var _this = this;
        // Make context more type safe.
        var RenderContext = FormContext;
        return (React.createElement(RenderContext.Consumer, null, function (consumerState) {
            var fieldValue = get(consumerState.formValues, _this.props.field);
            var fieldError = get(consumerState.errors, _this.props.field, '');
            var fieldDirty = get(consumerState.dirty, _this.props.field, false);
            var fieldTouched = get(consumerState.touched, _this.props.field, false);
            return _this.props.render({
                fieldValue: fieldValue,
                error: fieldError,
                dirty: fieldDirty,
                touched: fieldTouched,
                field: _this.props.field,
                form: consumerState,
                onChange: consumerState.onChange(_this.props.field)
            });
        }));
    };
    return AutosaveField;
}(Component));
export { AutosaveField };
